// File: assets/kmpod.js
// Author: King & McGaw (web@kingandmcgaw.com)
// Requirements:
//    jQuery (included by theme.liquid)
//      - current version 3.3.1 (out of date/vulnerable) see: https://snyk.io/test/npm/jquery/3.3.1
//    lodash.js (included by product.kmpod.liquid)
//      - current version 4.17.15 (up to date as of 04/02/2021)
//      - https://lodash.com/docs/4.17.15
//
// Description:
//    This file runs after Shopify option_selection.js does it's magic
//    1. a single <select> element is added to the html from product.liquid
//    2. option_selection.js is a Shopify lib which converts it into 3 individual <select>s based on the available options
//    3. Finally this script replaces the 3rd <select> with a list of frame option links
//    4. ENO: the first <select> is removed because it currently only contains 1 option "art print"
//
// NB: even though this is an `object`, it does not maintain state of any kind. It's just a bag of namespaced functions.
// It also uses 3 global variables (yuk). see snippets/product-kmpod.liquid.

window.KMPod = {
  frameOptions: {
    none: {
      title: 'No frame',
      image: 'https://img.kingandmcgaw.com/i/frames/no_frame.jpg',
      class: 'no-frame'
    },
    black: {
      title: 'Black painted ash box',
      image: 'https://img.kingandmcgaw.com/framecache/si-880229.jpg_type-cornercrop_maxdim-85.jpg',
      class: ''
    },
    natural: {
      title: 'Natural oak box',
      image: 'https://img.kingandmcgaw.com/framecache/si-880232.jpg_type-cornercrop_maxdim-85.jpg',
      class: ''
    },
    white: {
      title: 'White painted ash box',
      image: 'https://img.kingandmcgaw.com/framecache/si-880231.jpg_type-cornercrop_maxdim-85.jpg',
      class: ''
    },
    gold: {
      title: 'Gold cushion',
      image: 'https://img.kingandmcgaw.com/framecache/si-880242.jpg_type-cornercrop_maxdim-85.jpg',
      class: ''
    }
  },

  initialize: function () {
    // console.log('KMPod.initialize')
    KMPod.checkTypeOption()
    KMPod.generateFrameOptions()
  },

  checkTypeOption() {
    // If there is only 1 media type (paper, canvas etc.) then hide the control
    if ($('select[data-option=option1] option').length == 1) {
      $('select[data-option=option1]').closest('.selector-wrapper').hide()
    }
  },

  generateFrameOptions: function () {
    // console.log('generateFrameOptions...')
    var frameOptionHtml = _.map(window.productVariants, function (variant) {
      var podMedia = variant.option1
      var podSize = variant.option2
      var podLabel = variant.option3
      var frame = KMPod.frameOptions[podLabel]

      return `<a class="frame-thumb ${frame.class}"
        onclick="KMPod.selectFrame('${podLabel}');return false;"
        href="?variant=${variant.id}"
        data-variant-id="${variant.id}"
        data-pod-media="${podMedia}"
        data-pod-size="${podSize}"
        data-pod-label="${podLabel}"
        title="${podMedia} / ${podSize} / ${podLabel} frame"
        ><img src="${frame.image}" alt="${frame.title}"></a>`
    })

    $('select[data-option=option3]').hide()
    $('select[data-option=option3]').parent().hide()

    $('.pod-frame-options')
      .html(`<div class="frame-options">${frameOptionHtml.join('\n')}</div>`)
      .show()
  },

  filterFrameOptions: function (selectedVariantId) {
    // console.log('filterFrameOptions', selectedVariantId)
    var selectedMedia = $('select[data-option=option1]').val()
    var selectedSize = $('select[data-option=option2]').val()

    // Hide all variant options
    $('[data-variant-id]').hide()

    // Then show options for selected media & size
    $(`[data-pod-media='${selectedMedia}'][data-pod-size='${selectedSize}']`).show()

    $('[data-variant-id]').removeClass('selected')
    $(`[data-variant-id="${selectedVariantId}"]`).addClass('selected')
  },

  // This function must always return a variant
  selectVariant: function (variant) {
    // console.log('selectVariant', variant)
    // If for some reason a variant is not available, disable the buy button
    if (variant && variant.available === false) {
      $('#AddToCart').prop('disabled')
      return variant
    }

    // If variant is null then the customer probably chose a combination of options that doesn't exist
    // ie. canvas with a frame or extra-small canvas etc.
    if (variant === null || variant === undefined) {
      if (KMPod.isCanvas()) {
        // If canvas was chosen, try to find a suitable replacement
        var replacementVariant = KMPod.findReplacement()
        if (replacementVariant) {
          return KMPod.selectVariant(replacementVariant)
        }
      }

      // If not canvas or replacement couldn't be found, default to first variant
      // We think this is better than disabling the buy button and making the customer wonder what went wrong
      return KMPod.selectVariant(window.productVariants[0])
    }

    // sanity check. this check probably isn't necessary
    if (KMPod.isVendorKmg(window.product)) {
      KMPod.filterFrameOptions(variant.id)
      KMPod.updatePageDescription(variant)
      $('#productSelect-kmpod-product-template').val(variant.id)
    }

    return variant
  },

  selectFrame(podLabel) {
    $('select[data-option=option3]').val(podLabel).trigger('change')
  },

  updatePageDescription: function (variant) {
    // console.log('updatePageDescription', variant)
    var metaFields = window.variantMetafields[variant.id]
    var productDescription = metaFields['product-description']

    var productSummary = []
    productSummary.push(KMPod.toTitleCase(productDescription))

    if (metaFields['product-height']) {
      var productDimensions = `${metaFields['product-height'].value} x ${metaFields['product-width'].value} cm`
      var imageDimensions = `${metaFields['image-height'].value} x ${metaFields['image-width'].value} cm`
    } else {
      var productDimensions = metaFields['product-dimensions-cm']
      var imageDimensions = metaFields['image-dimensions-cm']
    }

    productSummary.push(`Product size: ${productDimensions}`)
    productSummary.push(`Image size: ${imageDimensions}`)

    $('.km-product-summary').remove()
    var html = '<div id="km-product-summary" class="km-product-summary">' + productSummary.join('<br>') + '</div>'
    $('.select-container .selector-wrapper:eq(1)').after(html)
  },

  isVendorKmg: function (product) {
    if (product && product.vendor) {
      return product.vendor.match(/king.*mcgaw/i)
    } else {
      throw 'Product is missing. Cannot continue.'
    }
  },

  toTitleCase: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  },

  isCanvas: function () {
    return $('select[data-option=option1]')
      .val()
      .match(/canvas/)
  },

  findReplacement: function () {
    var productType = $('select[data-option=option1]').val()
    var productSize = $('select[data-option=option2]').val()

    return _.find(productVariants, function (variant) {
      return variant.option1 == productType && variant.option2 == productSize
    })
  }
}
